module.exports = __webpack_public_path__ + "static/media/avatar.6a06abcb.png";